module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page89"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page89"
    }
  }), _c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page89"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/text/9780062018465_Contents#chapter_02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2.")])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062018465_Contents#chapter_02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bildung")]), _vm._v(" and the Inborn Drive toward Perfection")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("W")])]), _vm._v("hile these specific developments were taking hold in Germany—changes to its religion, to its language, in its universities, in its public space, in its image of itself, and in its standing as a political power—Europe itself (and North America, too) was undergoing a set of no less profound changes, perhaps the most important change in thinking since the advent of Christianity. This was the advent of religious doubt."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n157",
      "id": "n157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("The period between 1687, when Isaac Newton’s discoveries in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Principia Mathematica")]), _vm._v(" confirmed and systematized the earlier observations of Nicolaus Copernicus, Johannes Kepler, and Galileo Galilei, and 1859, when Charles Darwin published "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("On the Origin of Species")]), _vm._v(", comprises a unique time span in the history of Western thought, though it is not always seen as such. It was a time when a purely religious purpose to life (salvation in a future state) was called into question "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("while there was as yet no other model to replace it")]), _vm._v(", when Darwin’s biological understanding of man had yet to appear. The fact that so much of Germany’s golden age came between these two dates—1687 and 1859—was to have profound consequences, consequences that affected Germany more than anywhere else. Intellectually speaking, the country was shaped during this crucial—unique—"), _c('a', {
    attrs: {
      "id": "page90"
    }
  }, [_vm._v("transitional period. In particular, and most important, this transitional period saw the development of historicism and the rise of biology.")])]), _c('a', {
    attrs: {
      "id": "page90"
    }
  }, [_c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Even by the end of the seventeenth century, fifty years before our starting point, there was no shortage of people in Europe who felt that the Christian religion had been gravely discredited. Protestants and Catholics had been killing each other in the hundreds of thousands, or millions, for holding opinions that no one could prove one way or the other. The observations of Kepler and Galileo transformed man’s view of the heavens, and the flood of discoveries from the New World promoted an interest in the diversity of customs and beliefs found on the other side of the Atlantic. It was obvious to many that God favored diversity over uniformity and that Christianity and Christian concepts—like the soul and a concentration on the afterlife—were not necessarily crucial elements since so many lived without them. It was in the sixteenth and seventeenth centuries, as the invention of printing matured, that vernacular translations of the Bible brought the book before a lay audience who now discovered that many traditions were actually nowhere to be found in the scriptures. The Bible also came under more systematic criticism when it was shown that the original Old Testament had been written not in Hebrew but in Aramaic, meaning the scriptures could not have been dictated to Moses by God: the Old Testament was not “inspired.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("As more and more people began to lose faith in the Bible, the calculations of the earth’s age based on the scriptures lost support also. The new science of geology suggested that the earth must be a great deal older than the 6,000 or so years it said in the Old Testament, and Robert Hooke, at the Royal Society in London, observed that fossils, now recognized for what they were, showed animals that no longer existed. This too suggested that the earth was much older than the Bible said: these species had come and gone before the scriptures were written. This had implications for the significance of the Creation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("The effect of all this was to produce a world where the very nature of doubt (or the reasons for it) was itself always changing. In fact, the growth of doubt went through four distinct stages: rationalistic supernaturalism, deism, skepticism, and, finally, full-blown atheism.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page90"
    }
  }, [_vm._v("Deistic thought was the most important stage. It came into existence ")]), _c('a', {
    attrs: {
      "id": "page91"
    }
  }, [_vm._v("first in England, from where it spread to both the Continent and America. The actual word “deist” was coined by the Genevois Pierre Viret (1511–71) to describe someone who believed in God but not in Jesus Christ. The anthropological discoveries in America, Africa, and elsewhere only underlined that all men had a religious sense but that on the other continents there was no awareness of Jesus. The deists were also influenced by new discoveries in the physical sciences, which suggested that God was not an arbitrary figure, as in ancient Judaism for example, but the maker of the laws that Copernicus, Galileo, Newton, and the others had uncovered. The deists in fact achieved a major transformation in the concept of God, arguably the greatest change in understanding since the development of ethical monotheism in the sixth century "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("B.C")]), _vm._v(". God lost his “divine arbitrariness” and was now regarded as a lawmaking and law-abiding deity.")])]), _c('a', {
    attrs: {
      "id": "page91"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("The atheists were predominantly French and were known as mechanists (as the intellectual heirs of Newton they were inspired by the idea of a mechanical universe). Voltaire was just one who thought that science had shown that the universe was governed by “natural laws,” which applied to all men and that countries—kingdoms, states—should be governed in the same way. Voltaire convinced himself that, through work, religious ideas would eventually be replaced by scientific ones. Man, he insisted, need no longer lead his life on the basis of atoning for his original sin; instead he should work to improve his existence here on earth, reforming the institutions of government, church, and education. “Work and projects were to take the place of ascetic resignation.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("These new attitudes, grounded in the recent advances of science, together with the fact that more and more people could "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("read")]), _vm._v(" of these discoveries, meant that the optimistic idea of progress was suddenly on everyone’s mind, and this too was both a cause and symptom of changes in religious belief. Until the likes of Michel de Montaigne and Voltaire, the Christian life had been a sort of intellectual limbo: people on earth tried to be good in the manner laid down by the church but, in effect, they accepted the notion of perfection at Creation, followed by the Fall and decline ever since. The faithful expected fulfillment only in “a future state.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page91"
    }
  }, [_vm._v("Pietism was of course a response to this, a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("religious")]), _vm._v(" response. It stressed the (moral) rewards available in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("this")]), _vm._v(" life. A quite different response, however, which matured as the century wore on, was the idea that if the rest ")]), _c('a', {
    attrs: {
      "id": "page92"
    }
  }, [_vm._v("of the universe was governed by (relatively) simple laws—accessible to figures like René Descartes, Isaac Newton, Gottfried Leibniz, Antoine Lavoisier, and Carl Linnaeus—then surely human nature itself should be governed by equally simple and accessible general laws.")])]), _c('a', {
    attrs: {
      "id": "page92"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("With this went a further profound change—the reconceptualization of the soul as the mind, the mind increasingly understood by reference to consciousness, language, and its relationship with this world, in contrast to the soul, with its immortality and preeminent role in the next world. This was, in other words, the replacement of theology by biology (a word not introduced until 1802). As we shall see—and if an ugly neologism be allowed—the “biologification” of the world took place preeminently in Germany.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("The individual mainly responsible for this approach, at first, was the Englishman John Locke, in his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Essay Concerning Human Understanding")]), _vm._v(", published in 1690. In this book, prepared in draft in 1671, Locke himself used the word “mind,” not “soul,” and referred to experience and observation, rather than some “innate” or religious (revelatory) origin, as the source of ideas. Locke further argued that motivation was based on experience—nature—which helped form the mind, rather than derived from some transcendent force operating on the soul. One unsettling effect of this was to further remove God from morality. Morality has to be taught, said Locke; it is not innate. Arguably most important of all, he said that the sense of self, the “I,” was not some mystical entity relating to the soul, but an “assemblage of sensations and passions that constitutes experience.” This was a key ingredient in the birth of psychology, even if that term was not much used yet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Alongside the rise of psychology, in Locke’s hands, and the (gradual) replacement of the concept of the soul with that of the mind, went a closer study of the brain. Thomas Willis had carried out numerous dissections of brains, helping to show that the ventricles (the central spaces where the cortex was folded in on itself) had no blood supply and was therefore unlikely to be the location of the soul, as some believed. Madness was increasingly being explained as a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gemütskrankheit")]), _vm._v(", “failure of the mind,” understood as housed in a bodily organ, the brain. Yet more biologification.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page92"
    }
  }, [_vm._v("These changing beliefs were embodied, perhaps inevitably, in a work ")]), _c('a', {
    attrs: {
      "id": "page93"
    }
  }, [_vm._v("that took them to extremes. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("L’homme machine")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Man a Machine")]), _vm._v(") by the French surgeon Julien Offroy de La Mettrie, published in 1747, argued that thought is a property of matter “on a par with electricity,” coming down on the side of determinism, materialism, and atheism, all of which were to land the author in hot water. His nonetheless influential view was that human nature and animal nature were part of the same continuum, that human nature equated with physical nature; and he insisted that there were no “immaterial substances,” thus casting further doubt on the existence of the soul. Matter, he said, was animated by natural forces and had its own organizational powers. This, he said, left no room for God.")])]), _c('a', {
    attrs: {
      "id": "page93"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("La Mettrie’s book was as controversial as it was extreme, and it provoked a mighty backlash. That backlash was led from Germany.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HE")]), _vm._v(" R"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ISE OF")]), _vm._v(" H"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ISTORICISM")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("In Germany there were two important areas of particular interest that would have a long-term effect on the country’s intellectual life. These areas were history and biology, though aesthetics and the concept of genius also formed part of the picture.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Just as Richard Gawthrop has recently recovered a number of Pietistic writers and writings from obscurity and given them a new prominence, Peter Hanns Reill has done the same with seventeenth- and early eighteenth-century German historians. In doing this, he makes clear that the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aufklärung")]), _vm._v("—to distinguish it from the French, English, and Scottish Enlightenments—had a number of achievements to its credit by the time of Bach’s death, and certainly by the time of Friedrich the Great’s.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page93"
    }
  }, [_vm._v("The Aufklärung, he points out, came later than the “Western” Enlightenment (i.e., in France, England, and Scotland), “and so it could and did borrow from its neighbours.” Though they borrowed from Voltaire and Hume, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aufklärer")]), _vm._v(" (as Reill calls them), did so selectively, to address problems of specific concern in German intellectual life. Mostly, these stemmed from the impact of Leibnizian philosophy."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n158",
      "id": "n158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" According to Leibniz, both the physical and spiritual realms were characterized by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("change")]), _vm._v(". This is an unexceptional thing to say in the twenty-first century, but it was very different then: the Christian worldview implied not exactly a static state of affairs, as the Greeks had viewed their environment, but a "), _c('a', {
    attrs: {
      "id": "page94"
    }
  }, [_vm._v("world in limbo—Christians, even Pietists, were waiting for perfection in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("next")]), _vm._v(" world. Moreover, and this is a point we shall return to time and again, the change envisioned by Leibniz was teleological: it was understood as development "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("toward a specific goal")]), _vm._v(", a goal that was vaguely inherent in the nature of the entity undergoing change.")])]), _c('a', {
    attrs: {
      "id": "page94"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Here then is the crucial point: change was accepted in late seventeenth- and early eighteenth-century Europe, and Germany in particular, but it was expected to have a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("direction")]), _vm._v(", though no one knew what that direction was or what it entailed. Moreover, the discovery of that direction now lay in activities "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("outside")]), _vm._v(" the church.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page94"
    }
  }, [_vm._v("Once the principle of change had been accepted, the concept of history also changed (and so too did the understanding of politics, considered later). Until about the middle of the eighteenth century, the normal stance for German historians was similar to that of Sigmund Baumgarten, who argued that history’s main purpose was to confirm man’s impotence in the face of God’s will—in other words to show that history underlined the veracity of Christianity."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n159",
      "id": "n159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" In 1726, the Halle-trained historian and jurist Johann David Köhler announced that “the best chronologists date the beginning of the world on the 26th of October in the year 1657 before the Flood and 3,947 years before Christ’s birth. To be sure,” he continued, “the ancient Egyptians and Chaldeans, as well as the modern Chinese, make the world many thousands of years older, but Holy Scripture is more believable than all other books of heathen fables founded on the ancients’ search for fame.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n160",
      "id": "n160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("By 1760, however, a definite shift was discernible. Instead of using history to confirm specific Christian episodes, these thinkers (known in Germany as Neologists) attempted to steer a path between orthodox, deist, and Pietist beliefs. The Neologists did not deny the importance of dogma, but nor did they accept that it was universally valid. For example, they felt able to surrender Christian chronology without rejecting the rest of Christianity, and this was an important milestone in the development of doubt."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n161",
      "id": "n161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" The German Neologists argued that the Bible should be understood as a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("collection")]), _vm._v(" of books written at different times and in response to different circumstances. They took what we might regard as an anthropological approach: they accepted that God’s commands were transmitted in these books, but they also conceded that the transmission was carried "), _c('a', {
    attrs: {
      "id": "page95"
    }
  }, [_vm._v("out by human agents who were responding to specific circumstances. The importance of the books lay in the fact that they always expressed a moral law, but the message was dressed in what Johann Salomo Semler called a “local” or “provincial” dialect. On this reckoning, it would have been inappropriate “for God to have his message transmitted in Newtonian language at a time when that language would have been totally incomprehensible.” Similarly, it would be equally anachronistic for someone living in the eighteenth century to accept that the world was created in six days just because “this was the way a primitive nomadic people grasped and expressed God’s majesty.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n162",
      "id": "n162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Johann David Michaelis expanded this view. He argued that the way in which the ancient Israelites had transmitted their sacred knowledge was very different from that of eighteenth-century Europeans. Chronology, he insisted, was relatively unimportant to the Israelites of the Mosaic era. Instead, Moses provided his people with a selective genealogy, recording “only those events that had meaning in the memory of his people and revealed God’s message.” The rest was unimportant."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n163",
      "id": "n163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Moreover, given that the Bible was a collection of books compiled by single individuals, who lived at different times and places, it was only natural that contradictions would occur. With this bold move, the Neologists overturned the assault on Holy Scripture by asserting that the contradictions in the text actually "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("confirmed")]), _vm._v(" its validity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("This new view enabled imaginative scholars to suggest a fresh understanding of chronology. Johann Christoph Gatterer, for example, related the age of the people in the Bible to the Fall of man. Man’s life span during the biblical chronology, he observed, was divided into six levels, in the course of which life span declined from an average of 900–969 years (until the Flood), to 600 years, 450 years, 239 years (building the Tower of Babel), 120 years (the Mosaic era), to 70–80 years (since David’s time). Gatterer explained the change in life spans against the background of a hypothetical natural history. According to this, the earth—created perfect by God—took some time after Adam’s original sin to arrive at its present stage of imperfection. “The immediate post-Adamite air had been cleaner and healthier, the earth richer and more fertile, the fruits and vegetables bigger, better and more nourishing.” That is why people lived longer and why, he said, the earth had more people in it before the Flood than at any time since."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n164",
      "id": "n164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page96"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page96"
    }
  }, [_vm._v("In this way, then, as Peter Hanns Reill has noted, the chronology of the Christian creation myth became “hermetically sealed off” from the remainder of historical analysis."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n165",
      "id": "n165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" This allowed people to keep their faith, but it also allowed the development of historical understanding outside the biblical chronology. Although scholars might have disagreements about the actual course of history since biblical times, it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" now accepted that, in the interim, there had been development, evolution (though not yet in a Darwinian sense), and that development was accessible to the diligent historian. “The rise of historicism is one of the great intellectual revolutions of the modern age.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n166",
      "id": "n166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Another intellectual revolution of the seventeenth century, with important implications for historians, was the triumph of Natural Law. This came about partly through the astronomical/physical/mathematical discoveries of Copernicus, Kepler, Galileo, and Newton, and partly through the biological and anthropological discoveries in the New World, Africa, and elsewhere. Given the laws discovered by Newton and others, and the fact that “primitive” tribes in the newly discovered parts of the world lacked Christianity but still had religion and lived in civil societies, these patterns fostered the idea that there must be in human affairs fundamental regularities—laws—that existed much as gravity existed, only needing a Newton to uncover them. Natural Law was understood in this way “as the force that arranged things.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n167",
      "id": "n167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("The meaning of the words “nature” and “natural” were not always obvious. For classical thinkers, unaware for the most part of “primitive peoples,” the natural state was life in a healthy civil society. Christians, on the other hand, always made a distinction between the state of nature (itself divided into the “pure state” of nature and the “state of fallen nature”) and the state of grace. Men such as Thomas Hobbes and Hugo Grotius, however, attempted to redefine the idea of nature so as to arrive at a new explanation for the origin of things. Thomas Hobbes in particular concerned himself with the state of nature that existed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("before")]), _vm._v(" civil society. This too implies change, development, evolution."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n168",
      "id": "n168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Reill identifies three German scholars in particular who all taught at Göttingen and all built on Hobbes and embraced Natural Law to explain the evolution of society. Johann David Michaelis (1717–91) conceived "), _c('a', {
    attrs: {
      "id": "page97"
    }
  }, [_vm._v("of primitive society as a collection of states so small they “resembled families.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n169",
      "id": "n169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" Ruled by elected judges, these small states were so uncorrupted that authority could be exercised in a simple “parental” manner. The experience of such peoples was expressed in their sacred poetry. Gottfried Achenwall (1719–72) said that ever-larger states were created “by contract” between smaller ones; the aim was to ensure maximum and mutual happiness. The agreements that made up the contract formed the basic constitution which shaped the character of the state. Achenwall’s colleague Johann Stephan Pütter (1725–1807) thought there were other types of social organization that came between the family and the state. He called these "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gemeinde")]), _vm._v(" (a loose grouping of people) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Volk")]), _vm._v(" (a collection of families and/or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gemeinde")]), _vm._v("), which bodies he thought lacked sovereignty. None of this is totally satisfactory but it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" the beginning of an explanation of the formation of civil society in developmental terms. August Ludwig von Schlözer (1735–1809) summed up the new thinking: “Since the beginning of the human race, a beginning we do not know and cannot rationally reconstruct, three basic types of social organisation have developed in succession: familial ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("häusliche")]), _vm._v("] organisation, civil ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bürgerliche")]), _vm._v("] groups, and state-society ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Staatsgesellschaften")]), _vm._v("].” For him, the moment of state formation was the point separating history from prehistory. Here too the scriptural account of the Creation was sealed off. The biblical account was now held to apply solely to the Israelites, which allowed the Aufklärer to argue that the basic principle governing mankind as a whole was Natural Law."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n170",
      "id": "n170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("And so, in this way, history gradually acquired a new function—it was to discover how society in the past had developed so that future evolution might be understood."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n171",
      "id": "n171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("W"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HAT")]), _vm._v(" K"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("NOWLEDGE")]), _vm._v(" I"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("S")]), _vm._v(" C"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ONVEYED BY")]), _vm._v(" A"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("RT?")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("If societies developed over time, what force or forces propelled that change? Natural Law might be operating at some level but the Aufklärer were attracted by the notion that perfection was not a static quality inherent in the nature of things. Instead, they understood that perfection was to be achieved by “the forces of the spirit.” To them, the mind (itself a relatively "), _c('a', {
    attrs: {
      "id": "page98"
    }
  }, [_vm._v("new concept) was not a merely passive reflector of sensations but “possessed an inherent creative energy…Increasingly, they located the motor element of history in the actions of man’s spirit.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n172",
      "id": "n172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("The “science” of the relationship between experience and creation was called “aesthetics,” a word coined by Alexander Baumgarten in 1739. The link between aesthetics and history was that both disciplines, for the Aufklärer, “assumed the possibility of a leap on to a higher plane of understanding…Perfectibility, genius and the phenomenology of the spirit were the main elements in formulating a more comprehensive theory of historical development.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n173",
      "id": "n173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Baumgarten, Christian Wolff’s “most brilliant disciple,” was the first to investigate the field he himself identified. What, he asked, was “the type of knowledge conveyed by art?” Baumgarten conceived the view that the senses must be capable of perfection, just as reason was. But he did not think that this perfection corresponded to the way mathematics was perfectible. A picture or a poem was for Baumgarten “a sensuous representation of an image of perfection.” Perfection could be achieved through the act of creation—the perfection of a work of art lying in its unique ability “to weld diverse impressions and confused apperceptions into an individual whole that conjured up a pure image.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n174",
      "id": "n174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Baumgarten was joined by Johann Jakob Bodmer, who argued that poetry (and by implication other forms of art) was a form of truth equal, if not superior, to philosophy (to include what we call science), the more so because it was more closely related to history. This was an important insight because it suggested that the unique and distinctive essence of a nation is best found in its poetic and mythic traditions."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n175",
      "id": "n175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("For Bodmer the artist became a Promethean figure, a “wise creator,” whose vision “forces his contemporaries to think and act in a new mould,” someone who epitomizes his own times while attempting to change and improve them. Bodmer also introduced a teleological element: each creation of genius results in an expansion of consciousness, opening the path to the apprehension of a better—more perfect—world, enabling us to transcend the present."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n176",
      "id": "n176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("In fact, says Reill, by the 1760s this Leibnizian idea of perfectibility had become one of the central concepts of German aesthetics. Moses Mendelssohn (1729–86) was just one figure who was specific in his claims "), _c('a', {
    attrs: {
      "id": "page99"
    }
  }, [_vm._v("along these lines. In 1755 he had applied the idea of perfectibility to artistic understanding, claiming that “the healthful, the tasteful, the beautiful, the practical, all pleasures stem from the idea of perfection.” He made a distinction between the perfection of man’s physical nature, which he regarded as more or less complete, and the perfection of his inner nature, which had not yet been achieved: “Alone the inner man is incomplete…men have to work, to work tirelessly for improvement.” Mendelssohn, referred to as the “Jewish Socrates,” argued that there is a special faculty in the soul that functions solely in regard to beauty, enabling man to respond to beauty, to “know” it and recognize it in a way that analysis can never achieve. On this view, it was the soul that predisposed man to higher culture.")])]), _c('a', {
    attrs: {
      "id": "page99"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("For the aestheticians of the Aufklärung, then, all artistic creation, and by extension all historical creation, is the result of the inborn drive toward perfection, referred to by the German deist philosopher Hermann Reimarus as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("notion diretrix")]), _vm._v(". Furthermore, the idea of perfectibility linked all individual creations together. Perfection was defined as “the achievement of a harmony between inner life and outer life,” and that is what a masterpiece was, a harmony between spirit and nature.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page99"
    }
  }, [_vm._v("This vision of the creative genius of the Aufklärer was developed still further. It was in the genius that the two realms of the individual and the general came together. More and more, the genius was considered to have the qualities of a prophet. By 1760, the Aufklärer across a wide range of disciplines were involved in trying to understand the exact nature of genius. In his 1760 book, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Versuch über das Genie")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Truth about Genius")]), _vm._v("), Friedrich Gabriel Resewitz argued that genius was characterized by “intuitive knowledge” ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("anschauende Erkenntnis")]), _vm._v("), defined as the ability to grasp the general and the individual simultaneously. Resewitz was saying, in effect, that the product of genius is itself a form of perfect knowledge. In asserting this he implied that genius “samples” divine knowledge."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n177",
      "id": "n177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("The evolving concept of genius had a number of ramifications. First, the new understanding implied that historical change resulted from spiritual change, but it also carried the implication that change was not automatic, for genius was notoriously unpredictable. And since by definition (to the devout at any rate) every image of perfection could only be ultimately incomplete, direction was implied but the destination could "), _c('a', {
    attrs: {
      "id": "page100"
    }
  }, [_vm._v("never be reached. “Art as well as history had an infinite realm of future possibility.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n178",
      "id": "n178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Isaak Iselin, in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Über die Geschichte der Menschheit")]), _vm._v(" (History of Mankind), published in revised form in 1768, characterized history as man’s spiritual struggle to overcome nature. Conceived in this way, he was led to consider three ideal types of human behavior: man ruled by his senses, man ruled by his imagination, and man ruled by his reason, producing a threefold periodization of history: the state of savagery (senses), of cultivation (imagination), of human maturity/harmony among the three faculties (reason). In arriving at this organization, Iselin contributed to the German (as opposed, say, to the British or American) idea of freedom. For him, freedom was to be acquired through knowledge; it was an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("internal")]), _vm._v(" freedom that concerned him, in contrast to an outward—political—freedom."), _c('span', {
    staticClass: "footnoteRef"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Footnote_7",
      "id": "footnote7",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("*")])])]), _vm._v(" Furthermore, the realization of the future was for him, as for other Aufklärer, possible only through a conscious act. The future didn’t just happen; it was fashioned, fostered, crafted, and geniuses were to be the primary agents of this advance."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n179",
      "id": "n179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" Here were two ideas that were to have powerful ramifications in German intellectual history.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OETRY VS")]), _vm._v(". M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ATHEMATICS")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("At the center of the historicist approach is the conviction that a fundamental difference exists between the phenomena of nature and the phenomena of history, from which it follows that the social and cultural sciences are inherently different from the natural sciences."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n180",
      "id": "n180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" The Aufklärer also made a further distinction—between rational or abstract understanding on the one hand, and moral or “immediate” understanding on the other. Rational thought, they believed, is best suited to exploring the world external to man, while immediate understanding lends itself to the exploration of the human world. On this view, mathematics represents the ideal form of rational understanding, whereas poetry is the ideal manifestation of intuitive understanding. History, which is concerned with both the external world "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and")]), _vm._v(" the spiritual world, must draw from both. For the "), _c('a', {
    attrs: {
      "id": "page101"
    }
  }, [_vm._v("Aufklärer, the genius is not so much the great speculative philosopher but more likely a great poet. “Poetry both preceded and was superior to reflection…The great poet provides his people with an intuitive representation of the truths of their times at a level approaching divine understanding.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n181",
      "id": "n181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" The historian’s task, then, becomes an investigation of a people’s national character according to its sacred and creative writings. For the Aufklärer, historical understanding came to be regarded as on a par with the achievements of poets and artists because it enabled people “to understand their own humanity by apprehending the humanity of others.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n182",
      "id": "n182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("The importance of the poetic approach was central to the Romantic movement, and the difference between the cultural and natural sciences has been an important concern in Germany right up until the present day. In the late eighteenth century, the significance of poetry was highlighted early by the short-lived but intense flourishing of the Sturm und Drang (Storm and Stress) movement. The title was taken from a play by Friedrich Maximilian Klinger, actually a rather junior member of the movement but all of them—Johann Georg Hamann, Johann Gottfried von Herder, Johann Heinrich Merck, and Johann Michael Reinhold Lenz, in addition to Klinger—were characterized by extreme youth (Lenz was nineteen in 1770, Klinger eighteen) and by, in general, temperamental instability, the defiance of accepted modes of thought and norms of behavior, restlessness, discontent, even maladjustment. Their works, essentially middle class (they were all university men), disparaged the modern state and all mercantile enterprises, and they delighted in physical exercise and nature (the wilder the better). They attacked “polite” society and followed their intuition, believing life to be both tragic and exhilarating.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("It is possible to see the Sturm und Drang movement as very young and very tiresome but, as we shall see, in their more mature years, most of them went on to create great works. As we shall also see with the Nazarenes, the existence of an early group identity gave them a self-confidence they might otherwise have lacked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("The final and distinctive achievement of the historicist Aufklärer approach was the conception of a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bildungsstaat")]), _vm._v("—a state whose main ideal was to enrich the inner life of man."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n183",
      "id": "n183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page102"
    }
  }, [_c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HE")]), _vm._v(" O"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("RIGINS OF")]), _vm._v(" M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ODERN")]), _vm._v(" B"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IOLOGY")])])]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page102"
    }
  }, [_vm._v("This new idea of nature had another important set of ramifications which made a basic contribution to the revolution in European thought in the eighteenth century, and here too German writers helped lead the way. Gotthold Ephraim Lessing, Moses Mendelssohn, Johann Sulzer, and Thomas Abbt all criticized—and criticized bitterly—the shortcomings of the mechanistic approach and pointed instead to the biological world where, they felt, the timeless nature of Newtonian-type laws was completely inappropriate and inadequate. The study of living forms, they insisted, offered the opportunity for what they called “immediate” or “experiential” understanding. The experience of other people, animals, and plants was direct, unlike the experience of, for example, mathematics. This mode of understanding, Resewitz’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("anschauende Erkenntnis")]), _vm._v(", became the major approach to knowledge in the latter half of the eighteenth century. Aestheticians abandoned the study of the eternal rules of composition to examine instead the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("process")]), _vm._v(" of artistic creation; jurists turned away from their attempts to discover the eternal laws of civil association, preferring instead to focus on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("development")]), _vm._v(" of law within society; perhaps most important of all, natural scientists turned to the study of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("growth")]), _vm._v(" and development."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n184",
      "id": "n184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" This underlines just what a great intellectual revolution historicism was in helping to create the modern age.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("“The word ‘biology’ is a child of the nineteenth century.” Until the seventeenth century, biological science as we understand it now comprised two fields: natural history and medicine. As the seventeenth century gave way to the eighteenth, natural history began to break up into zoology and botany, although many people as late as Linnaeus and Jean-Baptiste Lamarck moved freely between the two. At much the same time, anatomy, physiology, surgery, and clinical medicine also diverged. To begin with, both anatomy and botany were practiced primarily by physicians (they dissected the human body and collected medicinal herbs), and animals were studied mainly as an aspect of natural theology."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n185",
      "id": "n185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" The underlying reality is that the so-called scientific revolution of the fifteenth, sixteenth, and seventeenth centuries actually occurred only in the physical sciences, leaving the biological sciences largely unaffected."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n186",
      "id": "n186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page103"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Long before the eighteenth century, the ancient Greeks had conceived the idea that there is a purpose—a predetermined end—in nature and its processes. By the seventeenth and eighteenth centuries, this ideal had coalesced around the notion of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("scala naturae")]), _vm._v(", the Great Chain of Being, culminating in man. The manifold adaptations of organisms to their environment—everywhere apparent—fostered the idea of a “harmony” in the natural world that could only have been produced by God. The apparent goal-directed processes in the development of individuals were just too conspicuous to be discounted. Final causes must be involved, as Immanuel Kant, among others, acknowledged (see Chapter 2).")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page103"
    }
  }, [_vm._v("Overall, the concept was known as cosmic teleology—the universe is proceeding toward some particular end, predetermined by God. Until the mechanism of natural selection was identified, many biologists (Lamarck was one) argued for the existence of nonphysical (even nonmaterial) forces that drive the living world “upward toward ever greater perfection.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n187",
      "id": "n187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")]), _vm._v(" This was known as orthogenesis. Leibniz, Linnaeus, Herder, and almost all British scientists shared this view, some of them as late as the middle of the nineteenth century.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("So, from the middle of the sixteenth to the middle of the nineteenth century, two schools of thought coexisted: the physical scientists believed that God, at the time of the Creation, had instituted eternal laws governing the processes of this world (essentially the deist view). Against that, devout naturalists—familiar with living nature—concluded that, so far as the diversity and myriad adaptations of living creatures are concerned, the mathematically based laws of Galileo and Newton were meaningless."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n188",
      "id": "n188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" Germany was one of the main centers of this latter group.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Within biology (to use the modern term), a new era of observation had begun with the work of the so-called German fathers of botany—Otto Brunfels (1488–1534), Hieronymus Bock (1489–1554), and Leonhart Fuchs (1501–66). The study of medicinal plants was popular throughout the later Middle Ages and was reflected in the publication of a number of herbals. Then, as a result of the great voyages in the age of exploration and the discovery of the New World, the immense variety of plant and animal life across the globe was realized."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n189",
      "id": "n189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" These German botanists provided a break from medieval works, which were endlessly copied myths and allegories. Instead, their descriptions were based on real plants observed in "), _c('a', {
    attrs: {
      "id": "page104"
    }
  }, [_vm._v("their natural habitat, with the result that their realistic drawings played much the same role in botany as those of Vesalius did in anatomy. Hieronymus Bock’s descriptions—in meticulous if colloquial German—were vividly drawn from his own observations. Importantly, he also broke with the alphabetical arrangements of earlier herbals, describing instead his own method “to place together, yet to keep distinct, all plants which are related and connected, or otherwise resemble one another.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n190",
      "id": "n190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" The German herbals are worth singling out because of the new classificatory principles they introduced. This early tradition of classification reached its climax in 1623 with the release of Caspar Bauhin’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pinax")]), _vm._v(", in which 6,000 kinds of plants were arranged in twelve books and seventy-two sections."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n191",
      "id": "n191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" Related plants were often put together because of their common properties, and each plant assigned to a genus and a species, though genera were not defined. In addition, there was in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pinax")]), _vm._v(" an implicit separation of the monocotyledons, and some nine or ten families of dicotyledons were brought together also. Already, reproduction was recognized as crucial.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Botanists from Conrad Gesner (1567) and Andrea Cesalpino (1583) to Linnaeus all recognized the importance of fructification for classification, but this still left great scope for argument owing to the multitude of characteristics available, all bearing on fructification."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n192",
      "id": "n192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" Debate was and was not helped by the fact that the number of known plants increased at an astonishing rate during the sixteenth and seventeenth centuries. In 1542, Leonhart Fuchs identified some 500 species, Bauhin in 1623 referred to 6,000 species, while John Ray in 1682 listed no fewer than 18,000."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n193",
      "id": "n193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" The need for order and classification was greater than ever, but the welter of new material was overwhelming. At much the same time, while all others around him were fixated on the concept of essentialism (according to which each species is characterized by its unchanging essence—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("eidos")]), _vm._v("—and separated from all other species by a sharp discontinuity), Leibniz stressed the opposite: continuity. Ernst Mayr, the German-born Harvard historian of biology, argues that Leibniz’s interest in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("scala naturae")]), _vm._v(", and the links between various life forms (as revealed in the earliest attempts at plant classification), helped prepare the ground for Linnaeus and, ultimately, for evolutionary thinking.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("A key figure here was Albrecht von Haller (1707–77) who began a number of wide-ranging animal experiments, examining the operation "), _c('a', {
    attrs: {
      "id": "page105"
    }
  }, [_vm._v("of various internal organs. Haller found no evidence for a “soul” governing physiological functions, but his studies did convince him that bodily organs have certain properties (irritability, for example) which are absent in inanimate nature."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n194",
      "id": "n194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(" Though it may sound primitive to us, Haller’s irritability concept was important because he was not a vitalist: for him organic matter was different from inorganic matter but the difference, however mysterious, was a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("natural")]), _vm._v(" and not a supernatural process. This helped form a climate of opinion whereby it was in Germany, toward the end of the eighteenth and the early nineteenth century, that the strongest resistance developed against the purely mechanistic understanding of the followers of Newton (though this is not to dismiss the role played in eighteenth-century biology by the Frenchman George Buffon, 1707–88, and the French-Swiss Charles Bonnet, 1720–93)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n195",
      "id": "n195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" Three biologists in particular may be mentioned, not forgetting the important role played by Immanuel Kant in Königsberg.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Johann Friedrich Blumenbach (1752–1840) led the way. The influence of his experiments and observations was immense—roughly half the important German biologists during the early nineteenth century studied under him or were inspired by him: Alexander von Humboldt, Carl Friedrich Kielmeyer, Georg Reinhold Treviranus, Heinrich Friedrich Link, Johann Friedrich Meckel, Johannes Illiger, and Rudolph Wagner, several of whom we shall meet again. Friedrich Schelling and Kant agreed that Blumenbach was “one of the most profound biological theorists of the modern era.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n196",
      "id": "n196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("His foundational theories were set out in a short work, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Über den Bildungstrieb und das Zeugungsgeschäfte")]), _vm._v(" (On the Formative Drive and the History of Generation). In this book, Blumenbach considered how the sperm, “by the subtle odour of its parts which are particularly adapted to causing irritation,” awakens the germ “from its eternal slumber.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n197",
      "id": "n197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" And he identified a crucial question: “Why is it that progeny always differs from its original progenitor?” while observing too that offspring often display a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("blend")]), _vm._v(" of parental traits. He was homing in on the idea of both genetics and evolution, except that he had parts of the theory upside down: in his view all the various peoples around the world were a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("degeneration")]), _vm._v(" from the Caucasian race.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Blumenbach’s central idea, the one that influenced Kant and Schelling "), _c('a', {
    attrs: {
      "id": "page106"
    }
  }, [_vm._v("so much, was that there is a kind of “Newtonian force” in the biological realm, which is the agent for organic structure and which he called the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bildungstrieb")]), _vm._v("."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n198",
      "id": "n198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" He had conceived this model after several experiments with the humble polyp. What struck Blumenbach about this organism was, first, that it could regenerate amputated parts “without noticeable modification of structure” and second, that the regenerated parts were always "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("smaller")]), _vm._v(" than the originals. Furthermore, this seemed to be true more generally. Where humans had suffered serious flesh wounds, Blumenbach observed that the repaired area was never quite as good as new but always retained a depression. He was led to conclude “First that in all living organisms, a special inborn "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trieb")]), _vm._v(" [drive, or motivating force] exists which is active throughout the entire lifespan of the organism, by means of which they receive a determinate shape originally, then maintain it, and when it is destroyed repair it where possible. Second, that all organized bodies have a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trieb")]), _vm._v(" which is to be distinguished from the general properties of the body as a whole as well as from the particular forces characteristic of that body. This "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trieb")]), _vm._v(" appears to be the cause of all generation, reproduction, and nutrition. I call it the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bildungstrieb")]), _vm._v(".”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n199",
      "id": "n199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Blumenbach believed that the Bildungstrieb was teleological in character and “immanent” in the material constitution of the organism. In a way, of course, the Bildungstrieb doesn’t explain anything—it is merely a name for a mysterious process. But that is what appealed to Kant. For what he insisted upon was that, even if nature somehow uses mechanical means to construct organized bodies, humans can never understand that process even from a theoretical point of view. The problem for Kant was that human understanding can only construct scientific theories that use the “linear” mode of causation. In the organic realm, on the other hand, “cause and effect are so mutually interdependent that it is impossible to think of one without the other…This is a teleological mode of explanation, for it involves the notion of a ‘final cause.’” Kant became convinced that it is impossible to produce functional organisms by mechanical means—for example, by chemical combination. He was impressed by the examples of misbirth, for him powerful evidence to suggest that something analogous to “purpose” operates in the organic realm, “for the goal of constructing a functional organism is always visible in the products of organic nature, including its unsuccessful attempts.” For Kant, therefore, "), _c('a', {
    attrs: {
      "id": "page107"
    }
  }, [_vm._v("it was self-evident that the life sciences rested on a different set of principles from those of the physical sciences."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n200",
      "id": "n200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Johann Christian Reil (1759–1813) studied in Göttingen during 1779 and 1780 and came into contact with the young Blumenbach. Timothy Lenoir, in his study of early German biologists, says Reil was possibly more original than Blumenbach. His treatise “Von der Lebenskraft,” in which he introduced his own conception of the vital force within a Kantian framework, was published in 1795 in the first volume of the new professional journal "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Archiv für die Physiologie")]), _vm._v(". Reil too believed that each organism shows “purposive organisation” ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("zweckmässige Form")]), _vm._v(") and that this was determined by the chemical affinities between the organic materials, “just as the seed ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kern")]), _vm._v("] of a salt crystal attracts particles according to a particular law in which the basis of its cubic shape is to be found.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n201",
      "id": "n201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" This was, then, a sort of halfway-house theory, between Blumenbach’s and Kant’s. In Reil’s view the germ, in the mother, “slumbers without developing, probably because its organisation has too little irritability ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reizbarkeit")]), _vm._v("]. The father enhances the animal force of the dormant germ perhaps through the addition of the fluid of his semen to the matter of the germ.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n202",
      "id": "n202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Carl Friedrich Kielmeyer (1763–1844) moved from Stuttgart to Göttingen, where he also was a pupil of Blumenbach from 1786 to 1788. His contributions helped to establish "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pflanzenchemie")]), _vm._v(", the beginnings of organic chemistry. In the course he taught on comparative zoology Kielmeyer conceived what he called the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Physik des Tierreichs")]), _vm._v(", the aim of which was to uncover the laws of organic form by comparing the anatomy of birds, amphibians, fish, insects, and worms. Kielmeyer also broke new ground when he used embryological criteria to establish affinities between animal forms. He realized that the patterns revealed in embryological development were confirmation that the system of animal organization did not require “the assumption of a special directive force "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("existing outside")]), _vm._v(" of the individual organism, through which the life and economy of organic nature is maintained.” (Italics added.) There was no need for any “supra-material” organizing force. Kielmeyer, like Blumenbach, was unimpressed by the traditional idea of a Great Chain of Being; instead, he became convinced that species were transformed into others, albeit in a distinctive way: “Many species have apparently emerged from other species, just as "), _c('a', {
    attrs: {
      "id": "page108"
    }
  }, [_vm._v("the butterfly emerges from the caterpillar…"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("They were originally development stages and only later achieved the rank of independent species")]), _vm._v("; they are transformed developmental stages. Others, on the other hand, are original children of the earth. Perhaps, however, all of these primitive ancestors have died out.” Kielmeyer noted that smaller organisms tended to have more offspring than larger ones, and from this concluded that there are “internal forces,” specific to species, that give rise to their characteristic structure and behavior."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n203",
      "id": "n203",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("In purely biological terms, then, these late eighteenth-century scientists and philosophers had three operating conclusions/beliefs."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n204",
      "id": "n204",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" First, it was the task of the new fields of zoology and botany to reproduce in the organic realm what physics had done in the inorganic realm—namely “to investigate the most universal phenomena of matter and the special classes of phenomena which are not further reducible to others.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n205",
      "id": "n205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" Second, they identified (or assumed) a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lebenskraft")]), _vm._v(" or Bildungstrieb as the shaping principle of every organized body. Finally, Kant emphasized that man’s reason was insufficient ever to discover these “natural purposes,” or “teleological agents,” in the organic realm.")]), _vm._v(" "), _c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HE")]), _vm._v(" R"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ISE OF")]), _vm._v(" E"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("VOLUTIONISM")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("This battle between mechanist thought and vitalist thought would continue throughout the eighteenth and nineteenth centuries, and even up until the first quarter of the twentieth century. But, as Ernst Mayr points out, the years between the publication of the tenth edition of Linnaeus’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Systema Naturae")]), _vm._v(" in 1758 and Darwin’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("On the Origin of Species")]), _vm._v(" in 1859 were a time of transition. During this transition period Lamarck published his theory of transformation, in 1809, which argued for an “intrinsic tendency of organisms to strive toward perfection” together with an ability to adjust to the environment (the inheritance of acquired characteristics). It was also during this transition period that “downward classification” was phased out, to be replaced by “upward classification.” In “downward classification,” the organic realm was divided/organized according to its internal logic, as it appeared to this or that theoretician, using his view of what nature actually consisted of, and in the belief that species differed in their very essence, an essence that reflected their "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("eidos")]), _vm._v(", their special "), _c('a', {
    attrs: {
      "id": "page109"
    }
  }, [_vm._v("substance. In “upward classification,” observations started with species, the irreducible basic building blocks, and then their similarities with other organisms were observed and codified, working upward to higher taxonomic groups."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n206",
      "id": "n206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("But the very idea of classification was itself evolving. For centuries the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("scala naturae")]), _vm._v(", the scale of perfection, had been virtually the only conceivable way of bringing order into diversity. The idea was less popular with botanists than with zoologists, however, since hardly any trend toward perfection was observable among plants, except for a general advance from algae to the phanerograms (the subkingdom of flowering plants). And so, other approaches to classification were tried. Organisms were placed on the scale of perfection according to their "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("affinity")]), _vm._v(" with less perfect or more perfect neighbors."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n207",
      "id": "n207",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" There was a conviction that similarity (of whatever kind) reflected an underlying causal relationship. Two kinds of similarity in particular were identified by German writers such as Friedrich Schelling and Lorenz Oken: true affinity and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("analogy")]), _vm._v(". “Penguins are related to ducks by true affinity but to the aquatic mammals by analogy. Hawks show affinity with parrots and pigeons, but are analogous to the carnivores among the mammals.” Such a reconceptualization seems bizarre but this approach proved crucial in the ensuing history of biology, influencing Richard Owen in his ideas of homology and analogy, which came to dominate comparative anatomy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Without these developments in thinking about classification, the theory of evolution probably could not have developed. Yet there was still some way to go. The great problem with evolution was that it could not be observed directly, unlike the familiar phenomena of physics, such as falling stones or boiling water. Evolution, plainly, can only be inferred and only then can such evidence as fossils or stratification be adduced. "), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n208",
      "id": "n208",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("To us, the time it took between the first glimmerings of evolutionism by Leibniz in his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Protogaea")]), _vm._v(" (1694) and the full-blown theory of Lamarck in 1809 seems inordinately long. Like Buffon, who had flirted with evolutionism all his life, Lamarck was French, and Darwin himself, of course, was British. Yet evolutionism was far more popular in Germany than anywhere else."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n209",
      "id": "n209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" Just how widespread it was there has been explored by several historians. Henry Potonié, Otto Heinrich Schindewolf, and Oswei Temkin are just three who have rescued the names of numerous "), _c('a', {
    attrs: {
      "id": "page110"
    }
  }, [_vm._v("early German evolutionists from oblivion: besides Blumenbach, Reil, and Kielmeyer, there were Friedrich Tiedemann, Reinecke, Voight, Tauscher, and Ballenstedt. Although it may come as a surprise that, with all these figures devoting their time to evolution, it should be an Englishman, Charles Darwin, who conceived the idea of natural selection, we should remember that, among the many people who set the stage for Darwin, the Viennese botanist Franz Unger stands out. Unger argued that the simpler aquatic and marine plants preceded the most complex varieties, that there must have been an original germ of all kinds of plants, that new species must have originated from already-existing ones and that all plants are united with each other “in a genetic manner.” Among Unger’s students was Gregor Mendel."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n210",
      "id": "n210",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("And so, in the late eighteenth century, in Germany, doubt, deism, Pietism, and the drive toward perfection—in history, in art, in biology—all came together to create a way of looking at the world, looking within, looking back, and looking forward all at the same time. It was a transitional period, when people were groping, tentatively attempting—perhaps without being aware of it—to replace the theological concept of mankind with a biological understanding.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("One man of influence who took up these ideas early was Wilhelm von Humboldt."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n211",
      "id": "n211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" Later on, Humboldt would be instrumental in the creation of the University of Berlin, an institution so important that it needs a chapter all to itself in any cultural history of Germany. To begin with, he was a student of Blumenbach and was much taken with his concepts of Bildung and Bildungstrieb."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n212",
      "id": "n212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" Nature, for Humboldt, consisted of specific individual centers of energy and activity, each center revealing its own character in the activity it displayed. Activity—sheer movement—was key here. In classical (Newtonian) physics, motion was always the result of some outside source. However, many thinkers, dissatisfied with the application of Newton’s science as an explanation for living systems, preferred what they called “the living order of nature,” where nothing stood still, where “self-generated motion” meant that every living part of nature was constantly in movement and, moreover, “this movement was not haphazard.” Matter, to them, contained an immanent principle of self-movement. “Unlike mechanical concepts of force (magnetism, electricity, "), _c('a', {
    attrs: {
      "id": "page111"
    }
  }, [_vm._v("gravitation), these internal powers were thought to operate directionally: they had an implicit goal towards self-realisation ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Vervollkommnung")]), _vm._v(").”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n213",
      "id": "n213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("This revised definition of matter required a redefinition of nature. In this new view, there is in nature an inner character which speaks through it. “Nature’s telos could only be intuited, never fully revealed as transparent.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n214",
      "id": "n214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" Humboldt’s gloss, which was essentially Blumenbach’s view, was that matter was composed of general and individual "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kräfte")]), _vm._v(" (powers or forces), each having its own nature. The most important of these immanent qualities were the general forces of Bildung, generation ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Zeugung")]), _vm._v("), and habit ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trägheit")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gewohnheit")]), _vm._v("). These qualities produced the individuals of which a nation was composed, making the nation an analog of an organized body. “Reality was defined as the striving of active powers or ideas to actualize themselves, that is to acquire form.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n215",
      "id": "n215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Biology apart, the root concept of Bildung, a neologism of the eighteenth century, lay in Martin Luther’s use of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bild")]), _vm._v(", meaning “image,” in two seminal biblical verses:")]), _vm._v(" "), _c('div', {
    staticClass: "extract",
    staticStyle: {
      "margin-left": "1.3em"
    }
  }, [_c('p', {
    staticClass: "extractTextNoIndent"
  }, [_vm._v("And God said, Let us make man in our own image, after our own likeness…So God created man in his own image, in the image of God created he him; male and female created he them.")]), _vm._v(" "), _c('p', {
    staticClass: "extractSource",
    staticStyle: {
      "margin-left": "25%"
    }
  }, [_vm._v("(G"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ENESIS")]), _vm._v(" 1: 26–7)")])]), _vm._v(" "), _c('div', {
    staticClass: "extract",
    staticStyle: {
      "margin-left": "1.3em"
    }
  }, [_c('p', {
    staticClass: "extractTextNoIndent"
  }, [_vm._v("But we all, with open face beholding as in a glass the glory of the Lord, are changed unto the same image from glory to glory, even as by the Spirit of the Lord.")]), _vm._v(" "), _c('p', {
    staticClass: "extractSource",
    staticStyle: {
      "margin-left": "25%"
    }
  }, [_vm._v("(2 C"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ORINTHIANS")]), _vm._v(" 3: 18).")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("It was, of course, the Pietists who had introduced the idea. For them it had an exclusively religious sense, but during the reigns of Friedrich Wilhelm I and Friedrich the Great, Bildung was secularized without losing the subjective ideal of personal perfection. “Even for those who rejected revealed religion and scriptural authority, Bildung offered a means of secular salvation through culture.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n216",
      "id": "n216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" Moreover, Bildung was open to "), _c('a', {
    attrs: {
      "id": "page112"
    }
  }, [_vm._v("everyone in a country where the public sphere was rapidly expanding (see Chapter 1).")])]), _c('a', {
    attrs: {
      "id": "page112"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page112"
    }
  }, [_vm._v("Bildung “was the culture of an emerging group that did not conceive of itself as bourgeois so much as it thought of itself as cultivated, learned and, most importantly, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("self-directing")]), _vm._v("…a man or woman of Bildung was not merely learned, but was also a person of good taste, who had an overall educated grasp of the world around him or her and was thus capable of ‘self-direction’ that was at odds with the prevailing pressure for conformity.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n217",
      "id": "n217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")]), _vm._v(" Bildung was in effect a secular form of Pietism: both embodied Leibniz’s and Christian Wolff’s notion of perfection.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Bildung, then, for someone like Humboldt, was partly a biological force, partly a spiritual necessity, partly an aspect of the natural world, like gravity. It also had religious overtones, in that it had grown out of Pietism: just as the Pietists could “improve on the Creation” and move closer to God by practically helping their neighbors in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("this")]), _vm._v(" world, so Bildung was an interior process whereby an individual could work on himself, or herself, to improve his or her self-consciousness, to move closer to perfection. The concept of genius—individuals whose creations offered glimpses of divine wisdom, glimpses of perfection—meant that self-cultivation, through studying the achievements of geniuses, offered the cultivated individual the prospect of achieving an approximation of divine wisdom right here on earth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("This was very much a halfway house of ideas that could only have existed in the transitional time between "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Principia Mathematica")]), _vm._v(" and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Origin of Species")]), _vm._v(", between doubt and Darwin. This historical/artistic/biological view of the world, within the framework of striving for perfection, was to shape many of Germany’s thinkers, not a few of whom were themselves the sons of Pietist pastors."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780062018465_Back_3#n218",
      "id": "n218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.3em"
    }
  }, [_vm._v("Bildung was, in its way, the most ingenious by-product of the development of doubt.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbe9b5d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062018465_Chapter_2.vue
// module id = 78
// module chunks = 0